<template>
<div class="">
  <VueFileAgent
    ref="vueFileAgent"
    :theme="theme"
    :multiple="multiple"
    :deletable="true"
    :meta="true"
    :accept="accept"
    :maxSize="'10MB'"
    :maxFiles="14"
    :helpText="helpText"
    :errorText="{
      type: 'Invalid file type. Only images or zip Allowed',
      size: 'Files should not exceed 10MB in size',
    }"
    @select="filesSelected($event)"
    @beforedelete="onBeforeDelete($event)"
    @delete="fileDeleted($event)"
    v-model="fileRecords"
  ></VueFileAgent>

  <vs-divider class="mb-5"/>

  <vs-button size="small" color="primary" :disabled="!fileRecordsForUpload.length" @click="uploadFiles()">
    Upload {{ fileRecordsForUpload.length }} {{fileRecordsForUpload.length > 1 ? 'files' : 'file'}}
  </vs-button>
  </div>
</template>

<script>

export default {
  data () {
    return {
      fileRecords: [],
      uploadUrl: 'https://www.mocky.io/v2/5d4fb20b3000005c111099e3',
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent' },
      fileRecordsForUpload: [] // maintain an upload queue
    }
  },
  props:['helpText', 'accept', 'module_name', 'multiple', 'theme', 'openFileInput'],
  methods: {
    uploadFiles () {
      if (this.module_name === 'Chat') {
        // 
        this.$emit('upload-chat-file', this.$refs.vueFileAgent.fileRecords)
        setTimeout(() => {
          this.$refs.vueFileAgent.fileRecords = []
          this.fileRecordsForUpload = []
        }, 2000)

      } else {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload)
      // this.fileRecordsForUpload = []
      }
    },
    deleteUploadedFile (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord)
    },
    filesSelected (fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
      this.$emit('fileSelected', this.$refs.vueFileAgent.fileRecords)
    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else if (confirm('Are you sure you want to delete?')) {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
      }
    },
    fileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
      }
    }
  },
  mounted () {
    if (!this.helpText) {
      this.helpText = 'Choose images or zip files'
    }
    if (!this.accept) {
      this.accept = 'image/*,.zip'
    }
    
  },
  watch: {
    openFileInput:{
      handler (newValue, oldValue) {
        if (this.module_name === 'Chat') {
          if (newValue === true) {
            setTimeout(() => {
              this.$refs.vueFileAgent.$el.children[0].children[2].click()
              this.$emit('switchOffOpenFileInput')
            }, 10)  
          }
        }
      }
    },
    accept: {
      handler (newValue, oldValue) {
        if (this.module_name === 'Chat') {
          if (newValue !== oldValue) setTimeout(() => {
            this.$refs.vueFileAgent.fileRecords = []
            this.fileRecordsForUpload = [] 
          }, 10)
        }
      }
    }
  }
}
</script>